//export const BaseIP = 'http://192.168.29.114:8080/';

export const BaseIP = 'https://attendance.lesdigitallibrary.in/';
// http://192.168.29.104:8080/api/enquery/send-email

//https://attendance.lesdigitallibrary.in/api/getdata
export const saveAttendanceApi=BaseIP+"api/attendance/"

export const getAttendanceApi=BaseIP+"api/getdata"

